import { gql } from '@apollo/client';

export const PATCH_NOTIFICATION_MUTATION = gql`
    mutation patchNotification($input: PatchNotificationInput!) {
        result: patchNotification(input: $input) {
            id
            isSticky
            isFeatured
            isPublished
            publishAt 
            unpublishAt 
            unfeatureAt
            weight
            brandIds
            locales {
                code
                name
                description
            }
        }
    } 
`;
